import React from 'react';
import { Card } from 'react-bootstrap';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';

// WAJIB: Inisialisasi modul 3D untuk Highcharts
Highcharts3D(Highcharts);

interface HighchartsPie3DProps {
    title: string;
    data: { name: string; value: number; color?: string | null }[];
}

const HighchartsPie3DComponent: React.FC<HighchartsPie3DProps> = ({ title, data }) => {

    const chartData = data.map(item => ({
        name: item.name,
        y: item.value,
        color: item.color || undefined,
    }));

    const getOptions = (): Highcharts.Options => ({
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
                depth: 45,
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '18px',
                fontWeight: 'normal',
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        // 1. Legend dinonaktifkan
        legend: {
            enabled: false
        },
        plotOptions: {
            pie: {
                innerSize: '60%',
                depth: 45,
                allowPointSelect: true,
                cursor: 'pointer',
                // 2. Data labels diaktifkan dan dikonfigurasi
                dataLabels: {
                    enabled: true,
                    // Format untuk menampilkan nama dan persentase
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    // Jarak dari tepi pie (nilai positif berarti di luar)
                    distance: 30
                },
                // Pastikan showInLegend juga false
                showInLegend: false
            }
        },
        series: [{
            type: 'pie',
            name: 'Source',
            data: chartData
        }],
        credits: {
            enabled: false
        }
    });

    return (
        <Card className="p-3 bg-white rounded shadow-sm h-100">
            <HighchartsReact
                highcharts={Highcharts}
                options={getOptions()}
                containerProps={{ style: { height: '400px', width: '100%' } }}
            />
        </Card>
    );
};

export default HighchartsPie3DComponent;